module.exports = __webpack_public_path__ + "img/faming12.e7d76969.png";